import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedOtherWorkPayRateLookupList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseOtherWorkPayRateLookups {
  ordering?: string;
  staff: string;
  limit?: string;
}

function useOtherWorkPayRateLookups({
  ordering,
  staff,
  limit = '20',
}: IUseOtherWorkPayRateLookups): UseInfiniteQueryResult<AxiosResponse<PaginatedOtherWorkPayRateLookupList>> {
  const fetchOtherWorkPayRateLookups = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedOtherWorkPayRateLookupList>> => {
      const params = pageParam;
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      if (staff) {
        params.staff = staff;
      }
      return client.get(`other-work-pay-rate-lookups/?${encodeUrlParams(pageParam)}`);
    },
    [limit, ordering, staff],
  );

  return useInfiniteQuery(['otherWorkPayRateLookups', ordering, staff], fetchOtherWorkPayRateLookups, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!staff,
  });
}

export default useOtherWorkPayRateLookups;
